import React, { useState } from 'react';
import ReactDOM from "react-dom";
import Button from '../../components/Button';
import DateInput from '../../components/forms/inputs/DateInput';
import Select from '../../components/forms/inputs/Select';

export default function ExportActions(props) {
  const {
    options,
  } = props;

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedRoute, setSelectedRoute] = useState(options[0].value);

  const handleSelectOption = (value) => {
    setSelectedRoute(value);
  }

  const getRoute = () => {
    return route(`web-api.export.${selectedRoute}`, {
      startDate: startDate,
      endDate: endDate,
    });
  }

  return (
    <div className="export-container">
      <div>
        <label className="mr-2">Start Date:</label>
        <DateInput
          onChange={setStartDate}
          clearable={true}
          value={startDate}
        />
      </div>
      <div>
          <label className="mr-2">End Date:</label>
          <DateInput
            onChange={setEndDate}
            clearable={true}
            value={endDate}
            className="ml-4"
          />
      </div>
      <div>
        <label className="mr-2">Table:</label>
        <Select
          key={selectedRoute}
          name="export-option"
          options={options}
          value={selectedRoute}
          onChange={handleSelectOption}
        />
      </div>
      <div className="align-self-end">
        <Button
          key={selectedRoute}
          classes={"btn btn-outline-eh-off-black"}
          href={getRoute()}
          label={"Export"}
        />
      </div>
    </div>
  );
}

const container = document.getElementById('export-actions');

if (container) {
  ReactDOM.render(
    <ExportActions
      options={JSON.parse(container.dataset.options)}
    />,
    container
  );
}
